module.exports = __webpack_public_path__ + "img/IMG_1539_L_Black_MockedUp.95d04dab.jpg";